import { render, staticRenderFns } from "./libros_estudiante.vue?vue&type=template&id=62ba46cb"
import script from "./libros_estudiante.vue?vue&type=script&lang=js"
export * from "./libros_estudiante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports